import { render } from "./PostPage.vue?vue&type=template&id=5974e3e2&scoped=true&ts=true"
import script from "./PostPage.vue?vue&type=script&lang=ts"
export * from "./PostPage.vue?vue&type=script&lang=ts"

import "./PostPage.vue?vue&type=style&index=0&id=5974e3e2&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/pontuei/pontuei-painel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5974e3e2"]])

export default __exports__